export default function(x) {
  return function() {
    return x;
  };
}



//////////////////
// WEBPACK FOOTER
// ./packages/element/node_modules/d3-chord/src/constant.js
// module id = 118
// module chunks = 0